import React from 'react';
import { components } from 'react-select';

export default ({ className, override }) => {
    const Group = React.memo(({ children, ...props }) => {
        return (
            components.Group && (
                <components.Group {...props} className={className} {...override.group}>
                    {children}
                </components.Group>
            )
        );
    });

    Group.displayName = 'Group';

    return Group;
};
